import { useEffect, useState } from "react";
import Card from "../ui/card-snippet";
import { CardContent } from "../ui/card";
import { AppCheckBox } from "../appComponents";

const FeaturesCard = ({ name, formikProps, title, data = [] }) => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    setFeatures(data);
  }, [data]);

  useEffect(() => {
    formikProps.setFieldValue(
      name,
      features.filter((item) => item.isSelected)
    );
  }, [features]);

  return formikProps ? (
    <>
      <div className="flex flex-col gap-2">
        <Card title={title}>
          <CardContent className="p-4">
            <div className="space-y-3">
              {features.map((item) => (
                <AppCheckBox
                  type="checkbox"
                  value={item.isSelected}
                  onChange={(val) =>
                    setFeatures(
                      features.map((feature) =>
                        feature.id == item.id
                          ? {
                              ...item,
                              isSelected: val,
                              sportFeatureId: item.id,
                            }
                          : feature
                      )
                    )
                  }
                  className="border-default-300"
                  text={item.name}
                />
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  ) : null;
};

export default FeaturesCard;
